import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceDropbox',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'serviceDropboxId',
        'dropboxName',
        'dropboxToken',
        'dropboxFolderName',
        'dataKbn',
        'modifyButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          serviceDropboxId: 'dropbox ID',
          dropboxName: 'dropbox名',
          dropboxToken: 'トークン',
          dropboxFolderName: 'フォルダ名',
          dataKbn: 'データ種別',
          modifyButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          serviceDropboxId: 'wp-5',
          dropboxName: '',
          dropboxToken: '',
          dropboxFolderName: '',
          dataKbn: '',
          modifyButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'serviceDropboxId',
          'dropboxName',
          'dropboxToken',
          'dropboxFolderName',
          'dataKbn'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceDropbox.categoryName,
      serviceName: state => state.serviceDropbox.serviceName,
      // model
      dropboxModel: state => state.serviceDropbox.dropboxModel,
      // form
      values: state => state.serviceDropbox.values,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'serviceDropbox/isRegister',
      isModify: 'serviceDropbox/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.dropboxModel, 'serviceDropboxUuid', this.modifyTargetId, 'serviceDropboxId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    dataKbnList () {
      return Constants.Service.DropboxDataKbn;
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpDropboxName: {
      get () {
        return this.values.inpDropboxName
      },
      set (value) {
        this.setInputValue({
          key: 'inpDropboxName',
          value: value
        })
      }
    },
    inpToken: {
      get () {
        return this.values.inpToken
      },
      set (value) {
        this.setInputValue({
          key: 'inpToken',
          value: value
        })
      }
    },
    inpFolderName: {
      get () {
        return this.values.inpFolderName
      },
      set (value) {
        this.setInputValue({
          key: 'inpFolderName',
          value: value
        })
      }
    },
    inpDataKbn: {
      get () {
        return this.values.inpDataKbn
      },
      set (value) {
        this.setInputValue({
          key: 'inpDataKbn',
          value: value
        })
      }
    },

    // disabled
    disableLedInterval () {
      return this.inpLedSetting !== 2
    },

    // validate
    inpDropboxNameIsValid () {
      return Validator.validText(this.inpDropboxName)
    },
    inpTokenIsValid () {
      return Validator.validText(this.inpToken)
    },
    inpFolderNameIsValid () {
      return Validator.validText(this.inpFolderName)
    },
    formIsValid () {
      return this.inpDropboxNameIsValid &&
        this.inpTokenIsValid &&
        this.inpFolderNameIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceDropbox/loadModel',
      initRegister: 'serviceDropbox/initRegister',
      initModify: 'serviceDropbox/initModify',
    }),
    ...mapMutations({
      setInputValue: 'serviceDropbox/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let dropboxParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        dropboxParams: dropboxParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.dropboxModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.dropboxModel, 'serviceDropboxUuid', this.modifyTargetId, 'serviceDropboxId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          dropboxName: this.inpDropboxName,
          dropboxToken: this.inpToken,
          dropboxFolderName: this.inpFolderName,
          dataKbn: this.inpDataKbn
        }
      }
      if (this.isModify) {
        parameters.serviceDropboxUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceDropbox'],
        [this.isRegister ?
          'v1ServiceDropboxPost' :
          'v1ServiceDropboxPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null
            if (this.isRegister) {
              this.initRegister()
            }

            // 一覧データを再読出し
            this.init()
            this.registerItem()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceDropboxUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceDropbox'],
        ['v1ServiceDropboxDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null
            this.modifyTargetId = null
            this.initRegister()

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'dataKbn':
          return Utility.getConstantsLabel(['Service', 'DropboxDataKbn'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.serviceDropboxUuid
      this.initModify({
        data: props.row
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.serviceDropboxUuid
      // confirm
      const id = Utility.getObjectArrayValue(this.dropboxModel, 'serviceDropboxUuid', this.deleteTargetId, 'serviceDropboxId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    }
  }
}